import { gql } from '@apollo/client'

export const deleteCourseMutation = gql`
  mutation DeleteCourse ($courseId: String!) {
    deleteCourse (courseId: $courseId) {
      id
    }
  }
`
